import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class AdvancePaidDto implements IAdvancePaidDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    paidAmount!: number;
    payDate!: Date;
    approver!: EmployeeSummaryDto;
    remark!: string | undefined;
    monthlyInstallment!: number;
    receiveAmount!: number;
    pendingAmount!: number;

    constructor(data?: IAdvancePaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.paidAmount = _data["paidAmount"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.remark = _data["remark"];
            this.monthlyInstallment = _data["monthlyInstallment"];
            this.receiveAmount = _data["receiveAmount"];
            this.pendingAmount = _data["pendingAmount"];
        }
    }

    static fromJS(data: any): AdvancePaidDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["paidAmount"] = this.paidAmount;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["remark"] = this.remark;
        data["monthlyInstallment"] = this.monthlyInstallment;
        data["receiveAmount"] = this.receiveAmount;
        data["pendingAmount"] = this.pendingAmount;
        return data; 
    }
}

export interface IAdvancePaidDto {
    id: number;
    employee: EmployeeSummaryDto;
    paidAmount: number;
    payDate: Date;
    approver: EmployeeSummaryDto;
    remark: string | undefined;
    monthlyInstallment: number;
    receiveAmount: number;
    pendingAmount: number;
}

